export const TEXT_STYLING_OPTIONS = {
  // resolutions: [
  //   '640:360',
  //   '800:600',
  //   '1024:768',
  //   '1280:720',
  //   '1280:800',
  //   '1280:1024',
  //   '1360:768',
  //   '1366:768',
  //   '1440:900',
  //   '1536:864',
  //   '1600:900',
  //   '1680:1050',
  //   '1920:1080',
  //   '1920:1200',
  //   '2048:1536',
  //   '2560:1080',
  //   '2560:1440',
  //   '3440:1440',
  //   '3840:2160',
  // ];
  fonts: [
    'Arial',
    'Verdana',
    'Sans-serif',
    'Courier New',
    'Lucida Console',
    'Monospace',
    'Times New Roman',
    'Georgia',
    'Serif',
  ],
  fontStyles: ['normal', 'italic', 'bold'],
  textDrawTypes: ['fill', 'stroke'],
  textSizes: [
    '9px',
    '10px',
    '13px',
    '16px',
    '18px',
    '24px',
    '30px',
    '32px',
    '40px',
    '46px',
    '48px',
    '72px',
  ],
};
